import PropTypes from 'prop-types'

export default {
  data: PropTypes.object,
  containerMessage: PropTypes.string,
}
